import React from 'react';
import styled from 'styled-components';
import background from './assets/background.png';

export type WelcomePageProps = {
  title?: string;
  subTitle?: string;
};

export const Welcome: React.FC<WelcomePageProps> = (
  props: WelcomePageProps,
) => {
  const defaultTitle = 'System Upgrade In Progress';
  const defaultSubTitle =
    'The service is expected to resume at 12 November 2024 (Hong Kong Time).';

  const welcomeTitle = !(process.env.REACT_APP_WELCOME_TITLE as string)
    ? defaultTitle
    : process.env.REACT_APP_WELCOME_TITLE;

  const welcomeSubTitle = !(process.env.REACT_APP_WELCOME_SUB_TITLE as string)
    ? defaultSubTitle
    : process.env.REACT_APP_WELCOME_SUB_TITLE;
  return (
    <Container>
      <div className="info-container">
        <div className="flex flex-col justify-center items-center align-center w-full h-full">
          <h1
            style={{
              fontSize: '2.5rem',
              fontWeight: '500',
              marginBottom: '0',
            }}
          >
            {welcomeTitle}
          </h1>
          <h2
            style={{
              fontSize: '1rem',
              marginTop: '1rem',
              color: '#000000',
            }}
          >
            {welcomeSubTitle}
          </h2>
        </div>
      </div>
      <img src={background} alt="background" />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    position: absolute;
    bottom: 7rem;
    z-index: -1;
    opacity: 0.7;
  }

  .info-container {
    width: 45rem !important;
    min-height: 28rem;
    height: max-content;
    padding: 1rem 4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 5rem;
    background-color: #e9e9e9 !important;
    opacity: 0.9;
    border-radius: 0.5rem;
    z-index: 0;
  }

  h1 {
    margin: 1rem;
    font-size: 1.5rem;
    text-align: center;
    font-weight: bold;
    color: #951d1d;
    z-index: 2;
  }

  h2 {
    font-size: 1rem;
    margin-bottom: 2rem;
    padding: 0;
    font-weight: 500;
    text-align: center;
    z-index: 2;
  }
`;
